import React from 'react'
import {h3, text} from '../typography/index'
import GiftForm from '../gift-form'
import GiftLargeForm from '../gift-large-form'
import * as API from '../../service/user'
import analytics from '../../shared/analytics'
import {SANDBOX} from '../../shared/settings'
import Modal from '../modal'
import {content} from '../gift-texts/gift-texts'
import Button from '../common/button'
import GiftContext from '../../context/context'
import {getParamFromUrl} from '../../utils/url'
import {getLangFromRouter} from '../../utils/getLangFromRouter'
import {REFERRAL_MODE, PROMO_MODE} from '../../shared/modes'
import {CONTENT_SIGNUP, CONTENT_DONE} from '../../shared/contentStates'
import {getStrapiData} from '../../service/user'
import Innovator from './innovator'
import Spinner from './innovator/loader/spinner'

class Gift extends React.Component {
  static contextType = GiftContext
  content = React.createRef()
  state = {
    contentState: null,
    modalError: null,
    isLoading: true,
    content: null
  }

  closeModal = () => {
    if (this.state.modalError.link) window.location.replace('https://flyxo.com')
    else this.setState({modalError: false})
  }

  errorModal = (key, action = 'close') => {
    const actions = {
      flyxo: {
        text: 'Go to FlyXO',
        link: 'https://flyxo.com',
      },
      close: {
        text: 'Try again',
        link: null,
      },
    }

    const modalError = actions[action]
    modalError.message = key.message

    this.setState({modalError, isLoading: false})
  }
  switchContent = (contentState) => {
    this.setState({contentState})
  }

  async componentDidMount() {
    const code = getParamFromUrl('code')
    const debug = SANDBOX === 'true' && getParamFromUrl('debug');
    if (!code) {
      this.errorModal({message: 'Sorry, please try to find promo code to use this page'}, 'flyxo')
      analytics.withoutCode()
      this.setState({isLoading: false})
    } else {
      try {
        await API.logOut()
        const res = debug ? {generatedBy: debug === REFERRAL_MODE} : await API.checkCode(code)
        const { questionnaire } = await API.getKYCData()
        const mode = res.generatedBy ? REFERRAL_MODE : PROMO_MODE
        const data = await getStrapiData(code)
        data[0].questionnaire = questionnaire || []
        if (code === 'BOCAWEST23' && questionnaire?.[0]){
          data[0].questionnaire = [data[0].questionnaire[0]]
        }

        this.context.updateState({
          mode,
          code,
          lang: getLangFromRouter(this.props.match),
        })
        this.setState({
          contentState: CONTENT_SIGNUP,
          content: data[0] ?? null,
          isLoading: false,
        })
        analytics.codeFound(mode)
      } catch (e) {
        this.errorModal({message: 'Sorry, we dont have this code'}, 'flyxo')
        analytics.codeNotFound()
        this.setState({isLoading: false})
      }
    }
  }

  getLegal(mode) {
    if (mode === REFERRAL_MODE) return content.referral.legal()
    if (mode === PROMO_MODE) return content.promo.legal(this.context.formData.lang, this.context.formData.code)
  }

  render() {
    const {content, contentState, isLoading} = this.state;

    return (
      <div className='innovator'>
        <Innovator content={content} isLoading={isLoading} renderForm={() => !isLoading && contentState && contentState !== CONTENT_DONE ? (
          this.props.lang === 'ar' || !this.props.isLargeForm ? (
            <GiftForm content={content} switchContent={this.switchContent} errorModal={this.errorModal}/>
          ) : (
            <GiftLargeForm content={content} switchContent={this.switchContent} errorModal={this.errorModal}/>
          )
        ) : contentState !== CONTENT_DONE ?  <div style={{margin: "25% auto"}}><Spinner/></div> : <SuccessMessage content={content} />}/>
        {this.state.modalError ? (
          <Modal small onClose={this.closeModal}>
            <div className="landing-modal">
              <div className="landing-modal__content">
                {h3({}, <span>Activation error</span>)}
                {text({margin: '30px 0'}, <span>{this.state.modalError.message}</span>)}
                {
                  <Button className="modal__button" onClick={this.closeModal}>
                    {this.state.modalError.text}
                  </Button>
                }
              </div>
            </div>
          </Modal>
        ) : null}
      </div>
    )
  }
}

const linksTransformer = (content) => {
  return content.replaceAll('<a','<a target="_blank"')
}

const SuccessMessage = ({content}) => {
  if (content?.redirect_after) {
    setTimeout(() =>  window.location.href = content?.redirect_url ? content.redirect_url : 'https://flyxo.com', 10000)
  }
  if (content?.data?.successScript){
    return (
      <>
        <div className= {content?.data?.invertedColors ? 'success_message_white' : 'success_message'} dangerouslySetInnerHTML={{__html: linksTransformer(content.success_message)}} />
        <span dangerouslySetInnerHTML={{__html: content?.data?.successScript}} />
      </>
    )
  }

  return <div className= {content?.data?.invertedColors ? 'success_message_white' : 'success_message'} dangerouslySetInnerHTML={{__html: linksTransformer(content.success_message)}} />
}

export default Gift
